export default "__VITE_ASSET__BUc3yGOi__"